import { render } from "./SignalIcon.vue?vue&type=template&id=6a023907&scoped=true"
import script from "./SignalIcon.vue?vue&type=script&lang=js"
export * from "./SignalIcon.vue?vue&type=script&lang=js"

import "./SignalIcon.vue?vue&type=style&index=0&id=6a023907&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a023907"

export default script